var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBassGuitar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 12.6 C11.96 11.19 12.6 9.28 11.96 8.36 C11.4 7.51 10.34 7.86 9.28 9.07 C8.22 10.27 7.79 11.26 6.66 11.96 C5.53 12.67 4.05 12.32 2.7 13.66 C1.08 15.29 1.71 18.05 3.83 20.17 C5.95 22.29 8.71 22.92 10.34 21.3 C11.61 20.03 11.33 18.47 12.04 17.48 C12.74 16.49 13.66 16.14 14.44 15.08 C15.15 14.09 14.58 13.24 13.59 13.1 C12.74 12.95 12.04 12.81 11.4 12.6 Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 12.6 L19.18 4.82",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.54 4.19 L20.66 2.07 C21.37 1.36 22.71 2.7 22.01 3.41 L19.88 5.53 Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18 16.56 L7.44 18.82",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBassGuitar);
export default __webpack_public_path__ + "static/media/bass-guitar.9f934370abf4ece5e404ec12643f4796.svg";
export { ForwardRef as ReactComponent };